import { Pipe } from '@angular/core';

@Pipe({
    name: 'search'
})

export class SearchPipe {
    transform(value, term) {

        if (!term) return value;

        term = term.toLowerCase();
        
        return value.filter((item) => JSON.stringify(item).toLowerCase().indexOf(term) != -1);
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/searchPipe.ts